/** Lair Finance stKAIA (Kaia chain 8217) — non-rebasing, value-accruing
 *  liquid-staked KAIA. `getRatio()` returns the 1e18-scaled
 *  KAIA-per-stKAIA exchange rate (equal to `totalStaking()/totalSupply()`).
 *  `totalStaking()` returns the total KAIA managed (incl. rewards), used
 *  as `totalAssets`.
 *
 *  stKAIA: `0x42952b873ed6f7f0a7e4992e2a9818e3a9001995` */
export const LairStKaiaAbi = [
  {
    name: 'getRatio',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'totalStaking',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
